import { motion } from 'framer-motion';
import PageWrapper from '../layout/PageWrapper';
import AnimatedBackground from '../layout/AnimatedBackground';
import EnvironmentPanoramaTabs from '../features/panorama/EnvironmentPanoramaTabs';

export default function Environment() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AnimatedBackground type="floating-shapes" className="fixed inset-0 -z-10" />
      
      <PageWrapper>
        {/* Header Section */}
        <motion.section
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="py-16 bg-gradient-to-br from-green-50 to-emerald-100 rounded-2xl mb-16"
        >
          <div className="max-w-6xl mx-auto px-6">
            <h1 className="text-4xl md:text-5xl font-bold text-dblue text-center mb-6">
              Learning Environments
            </h1>
            <p className="text-gray-600 leading-relaxed max-w-3xl mx-auto text-center text-lg">
              Discover our specialized learning environments designed to inspire creativity, exploration, and growth. 
              Each space offers unique opportunities for children to develop through play and discovery.
            </p>
          </div>
        </motion.section>

        {/* Panoramic Environment Tours */}

        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mb-16"
        >
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-dblue mb-4">
              360° Virtual Environment Tours
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Explore our specialized learning environments with immersive 360° tours. Each space is thoughtfully 
              designed to support different aspects of child development and creative expression.
            </p>
          </div>
          
          <EnvironmentPanoramaTabs />
        </motion.section>
        {/* Features Section - hidden */}
        {/* 
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mb-16"
        >
          <div className="grid md:grid-cols-2 gap-8">
            <motion.div
              className="bg-white rounded-2xl shadow-lg p-8"
              whileHover={{ scale: 1.02 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="flex items-center mb-4">
                <div className="bg-green-100 p-3 rounded-full mr-4">
                  <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 11.172V5z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-dblue">Creative Expression</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Our Theatre and Visual Arts rooms provide dedicated spaces for children to explore their creativity 
                through drama, art, and self-expression in supportive, inspiring environments.
              </p>
            </motion.div>

            <motion.div
              className="bg-white rounded-2xl shadow-lg p-8"
              whileHover={{ scale: 1.02 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="flex items-center mb-4">
                <div className="bg-blue-100 p-3 rounded-full mr-4">
                  <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-dblue">Physical Development</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Our outdoor playground and jungle play area offer exciting opportunities for physical development, and active play in safe, engaging outdoor environments.
              </p>
            </motion.div>
          </div>
        </motion.section>
        */}

        {/* Call to Action */}
        <motion.section
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="bg-white rounded-2xl shadow-lg p-8 text-center"
        >
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-dblue mb-6">Experience Our Learning Environments</h2>
            <p className="text-gray-600 leading-relaxed mb-8 text-lg">
              Our website offers a glimpse into our specialized spaces, but there's nothing like seeing 
              children actively engaged in these environments. Visit us to see how our spaces come alive 
              with learning and creativity.
            </p>
            <motion.div
              className="flex flex-col sm:flex-row gap-4 justify-center"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8 }}
            >
              <motion.a
                href="/enrollment"
                className="bg-green-500 text-white px-8 py-4 rounded-full font-semibold hover:bg-green-600 transition-colors duration-300 shadow-lg inline-block"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Schedule a Visit
              </motion.a>
              <motion.a
                href="/contact-us"
                className="bg-dblue text-white px-8 py-4 rounded-full font-semibold hover:bg-blue-700 transition-colors duration-300 shadow-lg inline-block"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Learn More
              </motion.a>
            </motion.div>
          </div>
        </motion.section>
      </PageWrapper>
    </div>
  );
}


